import { Drawer } from '@components/common';
import { SidebarJobSearchFiltersHub } from '@components/features/filters/hubs/SidebarJobSearchFiltersHub';
import { JobSearchFiltersProps } from '@type/filters';
import { useFilterDrawer } from '@components/contexts/FilterDrawerContext';

/**
 * @description The job search filters component. It contains the sidebar filters drawer.
 * * **queryParams** - the query params object.
 * * **setQueryParams** - the function to set the query params.
 */
export const JobSearchFilters = (props: JobSearchFiltersProps) => {
  // Destructure props
  const {
    queryParams,
    setQueryParams,
  } = props;

  // Get filter drawer state from context
  const { isOpen: drawerOpen, toggleDrawer } = useFilterDrawer();

  // Render component
  // **********************************************
  return (
    <Drawer
      onClose={toggleDrawer}
      isOpen={drawerOpen}
      position="right"
      panelClasses="!overflow-visible"
    >
      <SidebarJobSearchFiltersHub
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        toggleDrawer={toggleDrawer}
      />
    </Drawer>
  );
};
